import { MicrositeEventType } from "@nkr/enums/microsite-event-type";
import { IListItem } from "@nkr/models/list-item";
import { Button, Modal } from "react-bootstrap";

interface IProps {
    eventType: MicrositeEventType,
    show: boolean,
    onCancel: () => void,
    onConfirm: () => void,
    eventTypeList:IListItem[],
    deactivateMicrosite?: boolean
}

export default function StatusConfirmation({eventType, show, onCancel, onConfirm, eventTypeList, deactivateMicrosite}:IProps) {
    
    interface IBodyType {
        eventType : MicrositeEventType
        body: JSX.Element
    }

    const desc = eventTypeList.find(f => f.id == eventType)?.description;
    
    const bodies:IBodyType[] = [
        
        {
            eventType: MicrositeEventType.TooSick,
            body: <>
                <p>Change the patient's status to "{desc}"?</p>
                {deactivateMicrosite && <p>This action will deactivate the Microsite.</p>}
            </>
        },
        {
            eventType: MicrositeEventType.Died,
            body: <>
                <p>Change the patient's status to "{desc}"?</p>
                <p>This action will deactivate the Microsite.</p>
            </>
        },
        {
            eventType: MicrositeEventType.DuplicateEntry,
            body: <>
                <p>Change the microsite's status to "{desc}"?</p>
                <p>This action will deactivate the Microsite.</p>
            </>
        },
        {
            eventType: MicrositeEventType.ReadyForTransplant,
            body: <>
                <p>Change the microsite's status to "{desc}"?</p>
                <p>This action will activate the microsite if it is inactive.</p>
            </>
        },
        {
            eventType: MicrositeEventType.NeverAcceptedInvite,
            body: <>
                <p>Change the patient's status to "{desc}"?</p>
                <p>This action will deactivate the Microsite.</p>
            </>
        },
        {
            eventType: MicrositeEventType.NoLongerEnrolled,
            body: <>
                <p>Change the patient's status to "{desc}"?</p>
                <p>This action will deactivate the Microsite.</p>
            </>
        },
        {
            eventType: MicrositeEventType.PatientDeactivateRequest,
            body: <>
                <p>Change the patient's status to "{desc}"?</p>
                <p>This action will deactivate the Microsite.</p>
            </>
        },
        

    ];

    return (
        <Modal backdrop='static' show={show} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title><span>{desc} - Are you sure?</span></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {bodies.find(b => b.eventType == eventType)?.body}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={onConfirm}>Confirm</Button>
                <Button onClick={onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export const confirmationTypes:MicrositeEventType[] = [
    MicrositeEventType.TooSick,
    MicrositeEventType.Died,
    MicrositeEventType.DuplicateEntry,
    MicrositeEventType.ReadyForTransplant,
    MicrositeEventType.NeverAcceptedInvite,
    MicrositeEventType.NoLongerEnrolled,
    MicrositeEventType.PatientDeactivateRequest
]